import { motion } from "framer-motion";
import { Megaphone } from "lucide-react";

export const PromoBanner = ({ content }) => {
  if (!content?.enabled || !content?.text?.trim()) return null;
  return (
    <motion.div
      initial={{ height: 0, opacity: 0 }}
      animate={{ height: "auto", opacity: 1 }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className="bg-dill text-parchment overflow-hidden"
      data-testid="promo-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center justify-center gap-2">
        <Megaphone className="w-3.5 h-3.5 text-gold shrink-0" />
        <p className="text-xs sm:text-sm font-semibold tracking-wide text-center" data-testid="promo-banner-text">
          {content.text}
        </p>
      </div>
    </motion.div>
  );
};
